/* page-faq-mosaic.js — two progressive enhancements:
   1. Category-chip + search filter for the FAQ mosaic. Scoped to
      #ngv-faq-mosaic so nothing on the rest of the page is affected.
   2. Header clearance observer: write --ngv-header-clearance from the
      actual rendered theme header (+ announcement bar if present), so
      the page survives announcement-bar / logo / sticky-header changes.
   Degrades silently if any selector is missing. */
(function () {
  var root = document.getElementById('ngv-faq-mosaic');
  if (!root) return;

  /* ---------- 1. FAQ filter + search ---------- */
  var cards = root.querySelectorAll('.faq-card');
  var chips = root.querySelectorAll('.chip');
  var search = root.querySelector('#ngv-faq-mosaic-search');
  var empty = root.querySelector('#ngv-faq-mosaic-empty');
  var activeFilter = 'all';

  function apply() {
    var q = (search && search.value ? search.value : '').trim().toLowerCase();
    var anyVisible = false;
    cards.forEach(function (card) {
      var cat = card.getAttribute('data-cat');
      var matchesCat = activeFilter === 'all' || cat === activeFilter;
      var matchesQ = !q || card.textContent.toLowerCase().indexOf(q) !== -1;
      var show = matchesCat && matchesQ;
      card.classList.toggle('hidden', !show);
      if (show) anyVisible = true;
    });
    if (empty) empty.classList.toggle('hidden', anyVisible);
  }

  chips.forEach(function (c) {
    c.addEventListener('click', function () {
      chips.forEach(function (b) { b.setAttribute('aria-pressed', 'false'); });
      c.setAttribute('aria-pressed', 'true');
      activeFilter = c.getAttribute('data-filter');
      apply();
    });
  });
  if (search) search.addEventListener('input', apply);

  /* ---------- 2. iOS Safari orientation reflow ----------
     Placed BEFORE the header observer's early returns so it runs even
     on browsers without ResizeObserver or when theme header elements
     can't be found. After portrait→landscape→portrait, iOS Safari
     keeps grid/mosaic tracks at the landscape computed width; toggling
     display + reading offsetHeight forces a synchronous reflow.
     Two passes (50ms + 300ms) cover Safari and Chrome iOS rotation-
     event timing differences. */
  function forceReflow() {
    var d = root.style.display;
    root.style.display = 'none';
    void root.offsetHeight;
    root.style.display = d || '';
  }
  function onOrientation() {
    setTimeout(forceReflow, 50);
    setTimeout(forceReflow, 300);
  }
  window.addEventListener('orientationchange', onOrientation);
  if (window.matchMedia) {
    var mq = window.matchMedia('(orientation: portrait)');
    if (mq.addEventListener) mq.addEventListener('change', onOrientation);
    else if (mq.addListener) mq.addListener(onOrientation);
  }

  /* ---------- 3. Header clearance observer ---------- */
  if (!('ResizeObserver' in window)) return;
  var headerEls = [
    document.querySelector('.xo-announcement-bar'),
    document.querySelector('.xo-header__sticky')
  ].filter(Boolean);
  if (!headerEls.length) return;

  function updateClearance() {
    var total = 0;
    headerEls.forEach(function (el) {
      total += el.getBoundingClientRect().height;
    });
    /* Cap at 160px: defense against iOS Safari measuring a pre-hydration
       announcement-bar carousel or drawer-menu subtree as hundreds of px. */
    if (total > 0) {
      var capped = total > 160 ? 160 : total;
      root.style.setProperty('--ngv-header-clearance', capped + 'px');
    }
  }
  var ro = new ResizeObserver(updateClearance);
  headerEls.forEach(function (el) { ro.observe(el); });
  updateClearance();
  if (document.readyState === 'complete') updateClearance();
  else window.addEventListener('load', updateClearance);
})();
